export const daysArray = ["Воскресение","Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота"] 